import React, { useState } from 'react';

import { useUserPermission } from '@contexts/UserContext';

import { useContact } from '@hooks/API/Contact/UseContact';

import FeaturesDrawer from '@components/Features/FeaturesDrawer';
import NwIcon from '@components/Gui/NwIcon';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const FullFeatures = ({ currentContact, iconSize }) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const viewModelFeatures = useUserPermission(
        'ViewModelFeatures',
        currentContact && currentContact.Users && currentContact.Users.map((user) => user.UserID)
    );

    return (
        <>
            <PermissionBlock
                permission={viewModelFeatures}
                content={
                    <NwIcon
                        icon={byPrefixAndName.fasl['weight-scale']}
                        size={iconSize}
                        tooltip="See and edit all measurements, sizes and skills"
                        onClick={() => viewModelFeatures && setShowDrawer(true)}
                    />
                }
            />
            {showDrawer && <FeaturesDrawer contact={currentContact} onClose={() => setShowDrawer(false)} />}
        </>
    );
};

export default FullFeatures;
